import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Loader from '../../components/loader';
import HistoryInitial from './historyinitial';
import History from './index';

class HistoryPrereq extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const { assets, pairs } = this.props;

    const historyReady = (pairs && Object.keys(pairs).length) && (assets && assets.length);
    if (historyReady) {
      return (
        <HistoryInitial>
          <History />
        </HistoryInitial>
      );
    }
    return (
      <div>
        <div className="grid-x">
          <div className="cell small-12 medium-12 large-12">
            <div className="center-loader">
              <Loader logo />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  assets: state.assets.assets,
  pairs: state.assets.pairs,
});

export default withRouter(connect(mapStateToProps)(HistoryPrereq));
